// react
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

// components
import Pagination from "../../../../components/Pagination";

// actions

class PaginationContainer extends React.Component {
	static propTypes = {
		currentPage: PropTypes.number,
		pageCount: PropTypes.number,
		onSearch: PropTypes.func.isRequired,
		query: PropTypes.string.isRequired,
		letter: PropTypes.string.isRequired,
	};

	static defaultProps = {
		currentPage: 0,
		pageCount: 0,
	};

	handleClick = (page) => {
		this.props.onSearch({
			query: this.props.query,
			letter: this.props.letter,
			page,
		});
	};

	render() {
		const { currentPage, pageCount } = this.props;

		return (
			<div className="pagination-container" style={{}}>
				<Pagination onClick={this.handleClick} currentPage={currentPage} pageCount={pageCount} />
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	if (ownProps.selectionObjectId === null) {
		return {
			query: state.users.getIn(["_currentQuery", "query"]),
			letter: state.users.getIn(["_currentQuery", "letter"]),
			pageCount: state.users.getIn(["_currentQuery", "pageCount"]),
			currentPage: state.users.getIn(["_currentQuery", "currentPage"]),
		};
	}

	return {
		query: state.users.getIn(["_currentQuery", "query"]),
		letter: state.users.getIn(["_currentQuery", "letter"]),
		pageCount: state.users.getIn(["_currentQuery", "pageCount"]),
		currentPage: state.users.getIn(["_currentQuery", "currentPage"]),
	};
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PaginationContainer);
